<template>
  <v-row>
    <v-col cols="12" lg="4">
      <v-skeleton-loader class="mx-auto" :loading="loading" type="card">
        <v-card outlined>
          <v-card-title>
            <v-tooltip small top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon small color="grey lighten-1">mdi-information</v-icon>
                </v-btn>
              </template>
              <span>Top level category grouping of EDCs.</span>
            </v-tooltip>Major Expanded Diagnosis Clusters
          </v-card-title>
          <v-virtual-scroll :items="medcData" :item-height="45" height="400" :bench="benched">
            <template v-slot="{ item }">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.Description"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </template>
          </v-virtual-scroll>
        </v-card>
      </v-skeleton-loader>
    </v-col>
    <v-col cols="12" lg="4">
      <v-skeleton-loader class="mx-auto" :loading="loading" type="card">
        <v-card outlined>
          <v-card-title>
            <v-tooltip small top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon small color="grey lighten-1">mdi-information</v-icon>
                </v-btn>
              </template>
              <span>
                Diagnosis codes matched to EDCs share similar clinical characteristics
                <br />and are expected to evoke similar types of diagnostic and therapeutic responses.
              </span>
            </v-tooltip>Expanded Diagnosis Clusters
          </v-card-title>
          <v-virtual-scroll :items="edcCodes" :item-height="45" height="400" :bench="benched">
            <template v-slot="{ item }">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.Description"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </template>
          </v-virtual-scroll>
        </v-card>
      </v-skeleton-loader>
    </v-col>
    <v-col cols="12" lg="4">
      <v-skeleton-loader class="mx-auto" :loading="loading" type="card">
        <v-card outlined>
          <v-card-title>
            <v-tooltip small top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon small color="grey lighten-1">mdi-information</v-icon>
                </v-btn>
              </template>
              <span>Pharmacy morbidity group and lab marker descriptions.</span>
            </v-tooltip>RX - Lab
          </v-card-title>

          <v-virtual-scroll :items="rxmgData" :item-height="45" height="400" :bench="benched">
            <template v-slot="{ item }">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.Description"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </template>
          </v-virtual-scroll>
        </v-card>
      </v-skeleton-loader>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AiMarker',
  props: [
    'value',
    'patientID',
    'organizations',
    'insurance',
    'startDate',
    'endDate',
    'providers',
    'groups',
    'locations',
  ],
  data() {
    return {
      benched: 50,
      loading: false,
      dialog: false,
      reportData: [],
      fireReport: false,
      medcData: [],
      rxmgData: [],
      edcCodes: [],
      labMarkers: [],
    };
  },
  created() {
    this.getReport();
  },
  methods: {
    async getReport() {
      const { startDate } = this;
      const { patientID } = this;
      const { endDate } = this;
      const { insurance } = this;
      const organizations = this.organization;
      const { groups } = this;
      const provNums = this.providers;
      const locs = this.locations;

      let providers = [];
      let locations = [];

      if (provNums.length > 0) {
        provNums.forEach((prov) => {
          if (providers.indexOf(prov.Center_PCP_Number) === -1) {
            providers.push(prov.Center_PCP_Number);
          }
        });
      } else {
        providers = [];
      }

      if (locs.length > 0) {
        locs.forEach((loca) => {
          if (locations.indexOf(loca.Center_Location) === -1) {
            locations.push(loca.Center_Location);
          }
        });
      } else {
        locations = [];
      }

      // Check for pending request and if so cancel old one for new incoming
      this.cancelSearch();
      // Set the CancelToken
      this.cancelSource = axios.CancelToken.source();

      if (insurance.length !== 0) {
        this.loading = true;
        this.reportData = [];
        this.medcData = [];
        this.rxmgData = [];
        this.edcCodes = [];
        this.labMarkers = [];
        const response = axios
          .get(
            `api/ai/modal/aimarkers/orgs=${organizations}/groups=${groups}/providers=${providers}/locs=${locations}/${insurance}/${startDate}/${endDate}/${patientID}`,
            { cancelToken: this.cancelSource.token },
          )
          .then((response) => {
            this.reportData = response.data;
            this.medcData = response.data[0].medc_codes;
            this.rxmgData = response.data[0].rxmg_codes;
            this.edcCodes = response.data[0].edc_codes;
            this.labMarkers = response.data[0].lab_markers;
            this.loading = false;
            this.cancelSource = null;
          });
      }
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
  },

  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    // Watch every dropdown and run report again on change
    async groups() {
      this.getReport();
    },
    async providers() {
      this.getReport();
    },
    async locations() {
      this.getReport();
    },
    async startDate() {
      this.getReport();
    },
    async endDate() {
      this.getReport();
    },
    async patientID() {
      this.getReport();
    },
  },
};
</script>

<style>
.code-list {
  list-style-type: none;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
